import { lazy } from 'react'

export const PaymentProvider = lazy(() => import('./PaymentProvider'))
